import * as React from 'react';
import styled from 'styled-components';

import { IconSystemV2BlogPronunciation } from '@doltech/icons/SystemV2/IconSystemV2BlogPronunciation';
import { IconSystemV2StatusCheck2 } from '@doltech/icons/SystemV2/IconSystemV2StatusCheck2';
import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import { DolPopover } from '@doltech/ui/lib/figma/Popover/DolPopover';
import { ButtonIconPrimaryGeneral } from '@doltech/ui/lib/figma/Button/ButtonIconPrimaryGeneral/ButtonIconPrimaryGeneral';
import { TooltipContent } from './TooltipContent';
import { useFromScreens } from '@doltech/ui/lib/hooks/useDeviceQuery.hook';

const IconCheck = styled.div`
  position: absolute;
  right: -1px;
  bottom: 2px;

  display: flex;
  align-items: center;
  justify-content: center;

  background-color: ${colorsV2.white100};
  border-radius: 50%;
  pointer-events: none;
  user-select: none;
`;

const Container = styled.div`
  position: relative;

  display: flex;
  align-items: center;
`;

interface PronunciationProgressIconButtonProps {
  status?: 'not-yet' | 'done';
  onStartPronunciation?: () => void;
}

export const PronunciationProgressIconButton = (props: PronunciationProgressIconButtonProps) => {
  const { status, onStartPronunciation } = props;
  const [, from1024] = useFromScreens([0, 1024]);

  switch (status) {
    case 'done':
      return (
        <Container className="pronunciation-progress-button done">
          <DolPopover
            maxWidth="300px"
            className="action-write-sentence-tooltip"
            trigger="hover"
            placement="top-end"
            overlayClassName="no-arrow custom-inner-content bordered"
            content={
              <TooltipContent
                title="Bạn đã luyện phát âm câu này"
                description="Nhấn để xem chi tiết"
              />
            }
            disabled={!from1024}
          >
            <ButtonIconPrimaryGeneral
              size="large"
              type="green"
              colorStyle="matte"
              icon={<IconSystemV2BlogPronunciation />}
              onClick={onStartPronunciation}
            />
            <IconCheck className="icon-check">
              <IconSystemV2StatusCheck2 size={16} color="green100" />
            </IconCheck>
          </DolPopover>
        </Container>
      );
    case 'not-yet':
    default:
  }

  return (
    <Container className="pronunciation-progress-button">
      <DolPopover
        maxWidth="300px"
        className="action-write-sentence-tooltip"
        trigger="hover"
        placement="top-end"
        overlayClassName="no-arrow custom-inner-content bordered"
        content={
          <TooltipContent
            title="Bạn chưa luyện phát âm câu này"
            description="Nhấn để bắt đầu luyện tập"
          />
        }
        disabled={!from1024}
      >
        <ButtonIconPrimaryGeneral
          size="large"
          type="secondary"
          icon={<IconSystemV2BlogPronunciation />}
          onClick={onStartPronunciation}
        />
      </DolPopover>
    </Container>
  );
};
